import {Component, Input, OnChanges} from '@angular/core';
import {Moment} from 'moment';

@Component({
    selector: 'app-date-label',
    template: `
        <ng-container *ngIf="dateValue; else empty">
            {{ dateValue | date:'dd/MM/yyyy' }}
            <ng-container *ngIf="showAge">
                ({{ age }} ans)
            </ng-container>
        </ng-container>

        <ng-template #empty>/</ng-template>
    `
})
export class DateLabelComponent implements OnChanges {

    @Input() date: Date | Moment | string;
    @Input() showAge = false;

    dateValue: Date | null = null;
    age: number | null = null;

    ngOnChanges(): void {

        if (this.date instanceof Date) {
            this.dateValue = this.date;
        } else if (typeof this.date === 'string') {
            this.dateValue = new Date(this.date);
        } else {
            this.dateValue = this.date?.toDate?.() ?? null;
        }

        this.age = this.dateValue
            ? this.calculateAge(this.dateValue)
            : null;
    }

    private calculateAge(date: Date): number {
        const today = new Date();

        let age = today.getFullYear() - date.getFullYear();

        const monthDiff = today.getMonth() - date.getMonth();

        if (
            monthDiff < 0 ||
            (monthDiff === 0 && today.getDate() < date.getDate())
        ) {
            age--;
        }
        return age;
    }
}
